export const NAV_WIDTH_COLLAPSED = 56;
export const NAV_WIDTH_EXPANDED = 240;
export const NAV_TRANSITION = "220ms cubic-bezier(0.4, 0, 0.2, 1)";
export const MOBILE_BAR_HEIGHT = 52;
export const NAV_ITEM_HEIGHT = 42;
export const NAV_SUB_ITEM_HEIGHT = 36;
import { BREAKPOINTS_MAX } from "@dexibit/styles";

export const isMobileViewport = () => window.innerWidth <= BREAKPOINTS_MAX.mobile;
